module.exports = __webpack_public_path__ + "img/Palladium_Logo_(Gray)_RGB gold leaf.28fc7f7f.png";